



































import Vue from "vue";

export default Vue.extend({
  name: "Tabs",
  props: {
    tab_name: {
      type: String,
      required: true
    },
    current_tab: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {};
  },
  methods: {
    onClick() {
      this.$emit("click");
    }
  },
  computed: {},
  watch: {}
});
